// 과정 카드의 "만족도" 상태 배지에 쓰는 의미색.
// 의미색은 성공(초록)/주의(주황)/제한(빨강)처럼 상태를 전달하는 자리에만 쓰고,
// 대표색(brand) 및 포인트색(분야 seed 배지)과 겹치지 않게 구분합니다.
//
// 만족도는 사실 기반의 숫자만 표시하고, 색은 구간으로만 나눕니다:
//   90점 이상  → 초록 (높음)
//   80점 이상  → 주황 (보통)
//   80점 미만  → 회색 (낮음)
// 빨강(제한)은 만족도에는 쓰지 않습니다. 낮은 만족도는 '에러'가 아니기 때문입니다.
// 빨강은 자가진단 결과의 '제한' 판정에만 씁니다.

export interface SatisfactionBadge {
  label: string;
  className: string;
}

export function getSatisfactionBadge(satisfaction: number): SatisfactionBadge {
  const score = Math.round(satisfaction);

  if (satisfaction >= 90) {
    return {
      label: `만족도 ${score}점`,
      className: "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300",
    };
  }

  if (satisfaction >= 80) {
    return {
      label: `만족도 ${score}점`,
      className: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
    };
  }

  return {
    label: `만족도 ${score}점`,
    className: "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300",
  };
}